module.exports = __webpack_public_path__ + "img/rebuild_huang_mob_bg.da638972.png";